import { graphql, useStaticQuery } from 'gatsby';

const useSeoMetadata = () => {
  const { metaData } = useStaticQuery(graphql`
            query {
                metaData: contentfulPages(slug: {eq: "/"}) {
                  title
                  slug
                  metaDescription {
                    metaDescription
                  }
                  keywords
                  image {
                    description
                    file {
                      contentType
                      url
                    }
                    gatsbyImageData
                  }
                }
            }
            `
  );
  return metaData;
};

export default useSeoMetadata;